<header id="header"></header>
<div class="page">
  <body class="sdx">
    <swisscom-sign-file-reader></swisscom-sign-file-reader>
    <div id="notification-container"></div>
  </body>
</div>
